import React, {Component} from 'react'
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import ImageGallery from 'react-image-gallery';
import CircularProgress from '@material-ui/core/CircularProgress';
import { DPE, GES } from './react-dpeges';

import ContactForm from './contactForm'
import "react-image-gallery/styles/css/image-gallery.css";

class Estate extends Component {

    constructor(props){
        super(props);
        this.state = {
            tab: 'description'
        }
    }

    capitalizeFirstLetter(s) {
        return s.charAt(0).toUpperCase() + s.slice(1);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render(){
        const id = this.props.match.params.id;
        const estate = this.props.estatesState.estates.find(estate => estate.id._text === id);
        if (this.props.estatesState.isLoading) {
            return (
                <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
                    <CircularProgress className="loaderColor"/>
                </div>
            )
        }
        if (!estate) return <Redirect to="/" />;

        let images = estate.images ? estate.images.image.map(i => {
            return {
                original: i._cdata,
                thumbnail: i._cdata,
            }
        }) : [];

        let prix = 0;
        if (estate.prix) {
            prix = parseInt(estate.prix._text).toLocaleString(
                undefined, // leave undefined to use the browser's locale,
                            // or use a string like 'en-US' to override it.
                { minimumFractionDigits: 0 }
            );
        }
        // TODO: why return?
        if (prix === 0) return ''
        let relativeProperties = 0;

        return (
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <Link to="/" className="backToListBtn"><h4><i className="fa fa-angle-left fwicons" />Retour aux annonces</h4></Link>
                        <div className="heading-properties clearfix sidebar-widget">
                            <div className="pull-left">
                                <h3>{estate.titre ? estate.titre._cdata.trim() : "-"}</h3>
                                <p>
                                    <i className="fas fa-location-arrow fwicons"/>{estate.ville ? (estate.ville._attributes.humanName ? estate.ville._attributes.humanName : this.capitalizeFirstLetter(estate.ville._cdata)) : "-"} {(estate.quartiers && estate.quartiers.quartier.nom)? ', ' + estate.quartiers.quartier.nom._cdata : ''}
                                </p>
                            </div>
                            <div className="pull-right">
                                <h3><span>{prix}€</span></h3>
                                {estate.type_offre ?
                                    estate.type_offre._cdata === 'Location' ?
                                        <h5>
                                            Par Mois
                                        </h5>
                                    : ""
                                : ""}
                            </div>
                        </div>
                        <div className="properties-detail-slider simple-slider mb-40">
                            {estate.images ?
                                <ImageGallery items={images} />
                                :
                                ''
                            }
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                        <div className="properties-details-section sidebar-widget no-margin">
                            <div className="panel-box properties-panel-box Property-description">
                                <div className="panel panel-default">
                                    <div className="panel-body">
                                        <div className="tab-content">
                                            <div className="tab-pane fade in active">
                                                <div className="main-title-2">
                                                    <h1><span>Description</span></h1>
                                                </div>
                                                <p dangerouslySetInnerHTML={{__html: estate.corps ? estate.corps._cdata : "-"}}></p>
                                                <p className="reference-row">Référence du bien: {estate.reference._cdata}</p>
                                                <div className="emissionTables">

                                                {
                                                    (estate.cons_energie || estate.class_energie) ?
                                                    <div className="col-md-6 col-xs-12">
                                                        <div className="main-title-2">
                                                            <h5><span>CONS ENERGIE</span></h5>
                                                        </div>
                                                        <DPE value={estate.cons_energie ? parseInt(estate.cons_energie._cdata) : estate.class_energie._cdata}/>
                                                    </div> : null
                                                }
                                                {
                                                    (estate.emission_gaz || estate.class_emission_gaz) ?
                                                    <div className="col-md-6 col-xs-12 ">
                                                        <div className="main-title-2">
                                                            <h5><span>EMISSION GAZ</span></h5>
                                                        </div>
                                                        <GES value={estate.emission_gaz ? parseInt(estate.emission_gaz._cdata) : estate.class_emission_gaz._cdata}/>
                                                    </div> : null
                                                }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr />
                        </div>
                        <div className="properties-details-section sidebar-widget no-margin">
                            <div className="panel-box properties-panel-box Property-description">
                                <div className="panel panel-default">
                                    <div className="panel-body">
                                        <div className="tab-content">
                                            <div className="tab-pane fade in active features">
                                                <div className="properties-condition">
                                                    <div className="main-title-2">
                                                        <h1><span>État</span></h1>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                                            <ul className="condition">
                                                                <li>
                                                                    <i className="fas fa-asterisk fwicons"></i>Référence: {estate.reference ? estate.reference._cdata : "-"}
                                                                </li>
                                                                <li>
                                                                    <i className="fas fa-toilet fwicons"></i>{estate.wc ? estate.wc._text : '-'} WC
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                                            <ul className="condition">
                                                                <li>
                                                                    <i className="fas fa-th fwicons"></i>{estate.surface_habitable ? estate.surface_habitable._cdata : "-"} {estate.surface_habitable._attributes ? estate.surface_habitable._attributes.unit : "m"}<sup>2</sup>
                                                                </li>
                                                                <li>
                                                                    <i className="fa fa-bed fwicons" />{estate.chambres ? estate.chambres._text : '-'} Chambres
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                                            <ul className="condition">
                                                                <li>
                                                                    <i className="fas fa-warehouse fwicons"></i>{estate.parking._text} Parking
                                                                </li>
                                                                {estate.balcon && parseInt(estate.balcon._text) > 0 ? <li>
                                                                    <i className="fas fa-door-closed fwicons"></i>{estate.balcon._text} Balcon
                                                                </li> : ''}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr />
                        </div>
                        <div className="properties-details-section sidebar-widget no-margin">
                            <div className="panel-box properties-panel-box Property-description">
                                <div className="panel panel-default">
                                    <div className="panel-body">
                                        <div className="tab-content">
                                            <div className="tab-pane fade in active technical">
                                                <div className="properties-amenities">
                                                    <div className="main-title-2">
                                                        <h1><span>Équipements</span></h1>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                                            <ul className="amenities">
                                                                {estate.balcon ? <li><i className="fas fa-door-closed fwicons"></i>{estate.balcon._text} Balcon</li> : ''}
                                                                {estate.ascenseur && estate.ascenseur._cdata.toUpperCase() === 'OUI' ?
                                                                    <li><i className="fas fa-arrow-circle-up fwicons"></i>Ascenseur</li> : ''}
                                                                {estate.meuble && parseInt(estate.meuble._text) > 0 ?
                                                                    <li><i className="fas fa-couch fwicons"></i>Meubles inclus</li> : ''}
                                                                {estate.particularites ?
                                                                    <li><i className="fas fa-dot-circle fwicons"></i>{estate.particularites._cdata}</li> : ''}
                                                                {estate.parking && parseInt(estate.parking._text) > 0 ?
                                                                    <li><i className="fas fa-warehouse fwicons"></i>Parking</li> : null}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr />
                        </div>
                        <div className="properties-details-section sidebar-widget">
                            <div className="panel-box properties-panel-box Property-description">
                                <div className="panel panel-default">
                                    <div className="panel-body">
                                        <div className="tab-content">
                                            <div className="tab-pane fade in active technical">
                                                <div className="floor-plans">
                                                    <div className="main-title-2">
                                                        <h1><span>Plans d'étage</span></h1>
                                                    </div>
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td><strong>Surface</strong></td>
                                                                <td><strong>Pieces</strong></td>
                                                                <td><strong>WC</strong></td>
                                                            </tr>
                                                            <tr>
                                                                <td>{estate.surface_habitable ? estate.surface_habitable._cdata : "-"} {estate.surface_habitable._attributes ? estate.surface_habitable._attributes.unit : "m"}<sup>2</sup></td>
                                                                <td>{estate.chambres ? estate.chambres._text : '-'}</td>
                                                                <td>{estate.wc ? estate.wc._text : '-'}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div className="sidebar right">

                        <div className="sidebar-widget popular-posts">
                            <div className="main-title-2">
                                <h1>Propriétés <span>similaires</span></h1>
                            </div>
                            {
                                this.props.estatesState.estates.map(relEstate => {
                                    if(relEstate.type_offre_code._text === estate.type_offre_code._text &&
                                        relEstate.reference._cdata !== estate.reference._cdata &&
                                        relEstate.type_bien._cdata !== estate.type_bien._cdata &&
                                        relativeProperties<3) {
                                            relativeProperties+=1;
                                            return (
                                                <div className="media" key={relEstate.id._text}>
                                                    <div className="media-left">
                                                        <Link to={`/estate/${relEstate.id._text}`} >
                                                            <img className="media-object" src={relEstate.images.image[0]._cdata} alt="small-properties-1" />
                                                        </Link>
                                                    </div>
                                                    <div className="media-body">
                                                        <h3 className="media-heading">
                                                            <Link to={`/estate/${relEstate.id._text}`} >{relEstate.titre ? relEstate.titre._cdata.trim() : "-"}</Link>
                                                        </h3>
                                                        <div className="price">
                                                            €{parseInt(relEstate.prix._text).toLocaleString(
                                                                undefined, // leave undefined to use the browser's locale,
                                                                            // or use a string like 'en-US' to override it.
                                                                { minimumFractionDigits: 0 }
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )

                                    }
                                    return null;
                                })
                            }
                        </div>
                        <ContactForm estate={estate} />
                    </div>
                </div>
            </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        estatesState: state.estates
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: {}
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Estate);
